export default __webpack_public_path__ + "static/media/Helm of the Usurper.af3435e7.jpg";